import { useMutation } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateEmailExecTemplates } from './useEmailExecTemplates';

export function useCreateEmailExecAssistantTemplateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (template: Api.EmailExecAssistantTemplate) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (template: Omit<Api.EmailExecAssistantTemplate, 'id'>) => {
			return userSession.webServiceHelper.callAsync<Api.EmailExecAssistantTemplate>(
				'emailExecAssistant/templates',
				'POST',
				template
			);
		},
		onError,
		onSuccess,
		onSettled: () => {
			invalidateEmailExecTemplates();
		},
	});
}
